import { render, staticRenderFns } from "./sidebar-navigation.vue?vue&type=template&id=4ee8ab6a"
import script from "./sidebar-navigation.vue?vue&type=script&lang=js"
export * from "./sidebar-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports